import toast from 'react-hot-toast';
import axiosInstance from 'services/axiosMiddleware';

export async function getstudents(studentsData) {
  try {
    const response = await axiosInstance.post('students/getstudents', studentsData);
    if (response.data.status) {
      console.log('response.data', response.data);
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Error fetching Students data:', error);
    throw error;
  }
}
